import React from 'react';
import './styles.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © 2025 LLEO (<a href="https://sureal.ai/" target="_blank" rel="noopener noreferrer" className="footer-link">sureal.ai</a>). All rights reserved.
        </p>
        <div className="footer-links">
          <a href="mailto:contact@lleo.earth" className="footer-link">Contact Us</a>
          <span className="footer-separator">|</span>
          <a href="#" className="footer-link">Privacy Policy</a>
          <span className="footer-separator">|</span>
          <a href="#" className="footer-link">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
